/* ===========================================================================
   MAVELY SUBDOMAIN  v1   (MV116)
   ===========================================================================
   1. THE SHORTEN BOX — a "Subdomain" list in front of "Paste a long url".
      It only appears once at least one extra domain has been added, so until
      then the shorten box is exactly what it was. The pick is remembered on
      this browser.

   2. window.__mvShortOrigin(code) — the origin the new short link is written
      with. index-MV41Sec4.js (the app) builds the link as
          (__mvShortOrigin(code) || window.location.origin) + '/' + code
      so the result box, Copy link, the QR code, the NEW SHORTEN LINK badge in
      the Deals List and "Add my Description with my short link" all carry the
      chosen domain. mavely-dealsflow.v2 uses it for the badge it paints first.

   3. THE DASHBOARD part lives in mavely-subdomain-admin.v1.js (loaded when
      the browser is idle, like the other dashboard scripts): the
      "Add Subdomain" button in front of "User & Pass", the panel, the
      Hostinger guide. It talks to this file through window.MavelySubdomain.

   ADDITIVE: no existing file is edited by this script; it only adds its own
   nodes. The short CODE is the same kind of code as always, stored in the same
   table, so every link works on every one of your domains.
   Console: __mvSubdomain()
   =========================================================================== */
(function () {
  'use strict';

  if (window.__mvSubdomainV1) return;
  window.__mvSubdomainV1 = true;

  var API = '/api/subdomains.php';
  var CACHE_KEY = 'mv_sd_cache';
  var PICK_KEY = 'mv_sd_pick';

  /* ------------------------------------------------------------ helpers --- */
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function norm(h) {
    return String(h || '').trim().toLowerCase()
      .replace(/^[a-z][a-z0-9+.\-]*:\/\//, '').replace(/[\/?#].*$/, '').replace(/:\d+$/, '').replace(/\.$/, '');
  }
  function bare(h) { return norm(h).replace(/^www\./, ''); }
  function same(a, b) { a = bare(a); b = bare(b); return !!a && a === b; }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }
  function token() { try { return window.localStorage.getItem('sh_admin_token') || ''; } catch (e) { return ''; } }

  var here = norm(window.location.hostname);

  /* -------------------------------------------------------------- state --- */
  var state = { hosts: [], def: '', main: '', pick: '', loaded: false, admin: null };

  (function fromCache() {
    try {
      var c = JSON.parse(lsGet(CACHE_KEY) || 'null');
      if (c && Object.prototype.toString.call(c.hosts) === '[object Array]') {
        state.hosts = c.hosts.map(norm).filter(Boolean);
        state.def = norm(c.def || '');
        state.main = norm(c.main || '');
      }
    } catch (e) { /* nothing cached */ }
    state.pick = norm(lsGet(PICK_KEY) || '');
  })();

  /** The choices, current host first, then the main domain, then the extras. */
  function choices() {
    var out = [];
    function add(h, kind) {
      h = norm(h);
      if (!h) return;
      for (var i = 0; i < out.length; i++) if (same(out[i].host, h)) return;
      out.push({ host: h, kind: kind });
    }
    add(here, 'here');
    add(state.main, 'main');
    for (var i = 0; i < state.hosts.length; i++) add(state.hosts[i], 'extra');
    return out;
  }
  function hasChoice() { return choices().length > 1; }

  /** The host new links are made with: the pick, else the default, else this one. */
  function picked() {
    var list = choices();
    function inList(h) { for (var i = 0; i < list.length; i++) if (same(list[i].host, h)) return list[i].host; return ''; }
    return inList(state.pick) || inList(state.def) || here;
  }

  function originFor(host) {
    if (!host || same(host, here)) return window.location.origin;
    /* The page's own scheme; the port only matters on a test server. */
    return window.location.protocol + '//' + host + (window.location.port ? ':' + window.location.port : '');
  }

  window.__mvShortOrigin = function () {
    try { return hasChoice() ? originFor(picked()) : window.location.origin; }
    catch (e) { return window.location.origin; }
  };

  /* --------------------------------------------------------------- load --- */
  function apply(j) {
    if (!j || !j.success) return;
    state.hosts = (j.hosts || []).map(norm).filter(Boolean);
    state.def = norm(j['default'] || '');
    state.main = norm(j.main || '');
    if (j.admin) state.admin = j.admin;
    state.loaded = true;
    lsSet(CACHE_KEY, JSON.stringify({ hosts: state.hosts, def: state.def, main: state.main, at: Date.now() }));
    paint();
  }

  var STATIC = '/mv-subdomains.json';

  function getJson(url, headers) {
    return fetch(url, { credentials: 'same-origin', cache: 'no-cache', headers: headers || {} })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* The shorten box reads /mv-subdomains.json: a static copy of the list that
     the server rewrites on every save, so a page view costs no PHP request
     (and usually just a 304). If it is missing, /api/subdomains.php answers
     and re-creates it. The dashboard panel asks for `fresh` data, always from
     PHP, because it also needs the admin details. */
  function load(fresh) {
    function viaPhp() {
      var headers = {};
      var t = token();
      if (t) headers.Authorization = 'Bearer ' + t;
      return getJson(API, headers);
    }
    var p = fresh ? viaPhp() : getJson(STATIC).then(function (j) {
      var ok = j && j.success && Object.prototype.toString.call(j.hosts) === '[object Array]';
      return ok ? j : viaPhp();
    });
    return p.then(apply).catch(function () { /* the list simply stays as cached */ });
  }

  /* ================================================== 1. THE SHORTEN BOX === */

  /** The shorten box's own input: the url field that shares a row with the
      trash button. Found by structure, so it survives the language buttons
      translating its placeholder. */
  function shortenInput() {
    var list = document.querySelectorAll('input[inputmode="url"]');
    for (var i = 0; i < list.length; i++) {
      var p = list[i].parentElement;
      if (p && p.classList && p.classList.contains('flex-1') && p.querySelector('button')) return list[i];
    }
    return null;
  }

  function buildSelect() {
    var s = el('select', 'mv-sd-select');
    s.setAttribute('aria-label', 'Subdomain');
    s.title = 'Subdomain — the domain your new short link will use';
    s.addEventListener('change', function () {
      state.pick = norm(s.value);
      lsSet(PICK_KEY, state.pick);
      s.setAttribute('data-sig', '');
      fill(s);
    });
    return s;
  }

  function fill(s) {
    var list = choices(), cur = picked();
    var sig = list.map(function (o) { return o.host; }).join('|') + '#' + cur;
    if (s.getAttribute('data-sig') === sig) return;
    while (s.firstChild) s.removeChild(s.firstChild);
    for (var i = 0; i < list.length; i++) {
      var op = el('option', null, list[i].host);
      op.value = list[i].host;
      if (same(list[i].host, cur)) op.selected = true;
      s.appendChild(op);
    }
    s.setAttribute('data-sig', sig);
  }

  function paint() {
    var inp = shortenInput();
    if (!inp) return;
    var wrap = inp.parentElement, row = wrap.parentElement;
    var sel = wrap.querySelector('select.mv-sd-select');

    if (!hasChoice()) {
      if (sel) sel.parentNode.removeChild(sel);
      if (row) row.classList.remove('mv-sd-on');
      wrap.classList.remove('mv-sd-wrap');
      return;
    }
    if (!sel) {
      sel = buildSelect();
      wrap.insertBefore(sel, inp);
    } else if (sel.nextElementSibling !== inp) {
      wrap.insertBefore(sel, inp);
    }
    fill(sel);
    wrap.classList.add('mv-sd-wrap');
    if (row) row.classList.add('mv-sd-on');
  }

  /* Checked on every DOM change, cheaply: once the list is in place this is
     one querySelectorAll and two class checks. MutationObserver callbacks run
     before the browser paints, so the list appears in the same frame as the
     shorten box instead of pushing it around a moment later. */
  function watch() {
    paint();
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      if (!hasChoice()) {
        if (document.querySelector('select.mv-sd-select')) paint();
        return;
      }
      var inp = shortenInput();
      if (!inp) return;
      var prev = inp.previousElementSibling;
      var row = inp.parentElement && inp.parentElement.parentElement;
      if (prev && prev.classList.contains('mv-sd-select') && row && row.classList.contains('mv-sd-on')) return;
      paint();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------------------------------------------------------------- css --- */
  function styles() {
    if (document.getElementById('mvsd-css')) return;
    var s = document.createElement('style');
    s.id = 'mvsd-css';
    s.textContent = [
      /* the Subdomain list in the shorten box */
      /* sm and up (the shorten row is a single line there): the list, the url
         box and the bin share the first line; QR Code + Shorten move under it. */
      '@media (min-width:640px){.mv-sd-on{flex-wrap:wrap}',
      '.mv-sd-on>.mv-sd-wrap{flex:1 1 100%;min-width:0}',
      '.mv-sd-on>.mv-sd-wrap+*{margin-left:auto}}',
      '.mv-sd-select{flex:0 1 auto;max-width:46%;min-width:0;padding:0 34px 0 34px;border:2px solid #cbd5e1;',
      'border-radius:.75rem;background-color:#fff;color:#0f172a;font-weight:800;font-size:14px;line-height:1.2;font-family:inherit;',
      'cursor:pointer;box-shadow:0 1px 2px rgba(0,0,0,.05);text-overflow:ellipsis;appearance:none;-webkit-appearance:none;',
      'background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'16\' height=\'16\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%232563eb\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Ccircle cx=\'12\' cy=\'12\' r=\'10\'/%3E%3Cpath d=\'M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z\'/%3E%3C/svg%3E"),',
      'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'14\' height=\'14\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23475569\' stroke-width=\'2.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpath d=\'m6 9 6 6 6-6\'/%3E%3C/svg%3E");',
      'background-repeat:no-repeat,no-repeat;background-position:11px 50%,calc(100% - 11px) 50%}',
      '.mv-sd-select:focus{outline:none;border-color:#2563eb}',
      '@media (max-width:520px){.mv-sd-wrap{flex-wrap:wrap}.mv-sd-select{flex:1 1 100%;max-width:none;min-height:46px}}'
    ].join('');
    (document.head || document.documentElement).appendChild(s);
  }

  /* ------------------------------------------------------------- driver --- */
  function start() {
    styles();
    watch();
    load();
    if (window.console && console.info) console.info('[mavely-subdomain] v1 ready \u2014 Subdomain list in the shorten box');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* For mavely-subdomain-admin.v1.js and the console. */
  window.MavelySubdomain = {
    load: load,
    apply: apply,
    state: function () { return state; },
    choices: choices,
    picked: picked,
    norm: norm,
    same: same,
    here: here
  };
  window.__mvSubdomain = function () {
    return { hosts: state.hosts.slice(), default: state.def, main: state.main, picked: picked(),
             origin: window.__mvShortOrigin(), choices: choices() };
  };
})();
